import {Chat} from "./types";

const prefix = 'app_';
export const getKey = (key: string) => {
  return prefix + key;
}
export const setItem = (key: string, value: any) => {
  return localStorage.setItem(getKey(key), JSON.stringify(value));
}
export const getItem = (key: string) => {
  const item = localStorage.getItem(getKey(key));
  if(item) {
    return JSON.parse(item);
  }
  return undefined;
}
export const removeAll = (startsWith="") => {
  Object.keys(localStorage).forEach((key) => {
    if(key.startsWith(prefix+startsWith)) {
      localStorage.removeItem(key);
    }
  });
}

export const mergeChats = (source: Chat[], inbox: Chat[], callback: (chats: Chat[]) => Chat[]) => {
  const mergedInbox = [...inbox];
  source.forEach((chat: Chat) => {
    if(!mergedInbox.find(c => c.id === chat.id)) {
      mergedInbox.push(chat);
    }
  });
  mergedInbox.sort((a, b) => (a.lastMessage && b.lastMessage) ? b.lastMessage.timestamp - a.lastMessage.timestamp : 0);
  return callback(mergedInbox);
}